import { c as _c } from "react/compiler-runtime";
import { Breadcrumbs } from "@flat-ui";
import { getPreservedQueryParams, useAppParams } from "@router/router-helper";
import { getGroupByIdSelector } from "@store/groups/groups-selector";
import { companyMemberSelector } from "@store/members/members-selector";
import { getProjectByIdSelector } from "@store/projects/projects-selector";
import { selectedCompanyContextSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { getTeamByIdSelector } from "@store/teams/teams-selector";
import { currentUserSelector } from "@store/user/user-selector";
import { BreadcrumbEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback, useMemo } from "react";
import { useLocation, useMatches, useNavigate } from "react-router-dom";

/** Extended definition when using useMatches to provide types to the attributes that we know. */

/** Defines the data included to the breadcrumb handle. */

/**
 * SphereBreadcrumbs – wrapper around Breadcrumbs that builds the correct
 * breadcrumb list from React Router matches + app state.
 */
export function SphereBreadcrumbs() {
  const $ = _c(33);
  const matches = useMatches();
  const location = useLocation();
  let t0;
  if ($[0] !== location.search) {
    t0 = getPreservedQueryParams(location.search);
    $[0] = location.search;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const queryParams = t0;
  const navigate = useNavigate();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    projectId,
    groupId,
    memberId,
    teamId
  } = useAppParams();
  let t1;
  if ($[2] !== projectId) {
    t1 = getProjectByIdSelector(projectId);
    $[2] = projectId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const selectedProject = useAppSelector(t1);
  let t2;
  if ($[4] !== groupId) {
    t2 = getGroupByIdSelector(groupId);
    $[4] = groupId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const selectedGroup = useAppSelector(t2);
  let t3;
  if ($[6] !== memberId) {
    t3 = companyMemberSelector(memberId);
    $[6] = memberId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const selectedMember = useAppSelector(t3);
  let t4;
  if ($[8] !== teamId) {
    t4 = getTeamByIdSelector(teamId);
    $[8] = teamId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const selectedTeam = useAppSelector(t4);
  const currentUser = useAppSelector(currentUserSelector);
  const companyContext = useAppSelector(selectedCompanyContextSelector);
  let t5;
  if ($[10] !== companyContext || $[11] !== currentUser || $[12] !== matches || $[13] !== queryParams || $[14] !== selectedGroup || $[15] !== selectedMember || $[16] !== selectedProject || $[17] !== selectedTeam) {
    let t6;
    if ($[19] !== companyContext || $[20] !== currentUser || $[21] !== queryParams || $[22] !== selectedGroup || $[23] !== selectedMember || $[24] !== selectedProject || $[25] !== selectedTeam) {
      t6 = m_0 => typeof m_0.handle.breadcrumb === "function" ? m_0.handle.breadcrumb(m_0.params, {
        selectedProject,
        selectedGroup,
        selectedMember,
        selectedTeam,
        currentUser,
        loaderData: m_0.data,
        queryParams,
        companyContext
      }) : m_0.handle.breadcrumb;
      $[19] = companyContext;
      $[20] = currentUser;
      $[21] = queryParams;
      $[22] = selectedGroup;
      $[23] = selectedMember;
      $[24] = selectedProject;
      $[25] = selectedTeam;
      $[26] = t6;
    } else {
      t6 = $[26];
    }
    t5 = matches.filter(_temp).map(t6).flat().filter(_temp2);
    $[10] = companyContext;
    $[11] = currentUser;
    $[12] = matches;
    $[13] = queryParams;
    $[14] = selectedGroup;
    $[15] = selectedMember;
    $[16] = selectedProject;
    $[17] = selectedTeam;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const breadcrumbs = t5;
  let t6;
  if ($[27] !== navigate || $[28] !== trackEvent) {
    t6 = breadcrumb => {
      trackEvent({
        name: BreadcrumbEvents.navigateWithBreadcrumb
      });
      if (breadcrumb.link) {
        navigate(breadcrumb.link);
      }
    };
    $[27] = navigate;
    $[28] = trackEvent;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  const handleBreadcrumbClick = t6;
  let t7;
  if ($[30] !== breadcrumbs || $[31] !== handleBreadcrumbClick) {
    t7 = <Breadcrumbs breadcrumbs={breadcrumbs} onBreadcrumbClick={handleBreadcrumbClick} />;
    $[30] = breadcrumbs;
    $[31] = handleBreadcrumbClick;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  return t7;
}
function _temp2(b) {
  return Boolean(b?.text);
}
function _temp(m) {
  return Boolean(m.handle?.breadcrumb);
}